import { render, staticRenderFns } from "./DeviceRecorddashboard.vue?vue&type=template&id=4fa5f060&"
import script from "./DeviceRecorddashboard.vue?vue&type=script&lang=js&"
export * from "./DeviceRecorddashboard.vue?vue&type=script&lang=js&"
import style0 from "./DeviceRecorddashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports